export default "__VITE_ASSET__BkpILFp4__"